import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const JOB_ESTIMATE_LINK_SCHEMA = Object.freeze({
  PAYMENT_URL: null,
  PDF_RENDERING_URL: null,
  PDF_DOWNLOAD_URL: null,
});
const RECORD = generateSchema(JOB_ESTIMATE_LINK_SCHEMA);
const KEYS: any = generateKeys(JOB_ESTIMATE_LINK_SCHEMA);

export class JobEstimateLink extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get paymentUrl(): string {
    return this.get(KEYS.PAYMENT_URL);
  }

  get pdfRenderingUrl(): string {
    return this.get(KEYS.PDF_RENDERING_URL);
  }

  get pdfDownloadUrl(): string {
    return this.get(KEYS.PDF_DOWNLOAD_URL);
  }
}
